import { Botao, Cores, Corpo, Select, Icone, Titulo } from '@componentes-mu/componentes-mu'

import estiloTelaMapaUtilizacao from './styles.module.scss'

const TelaMapaUtilizacao = () => {
  const cabecalho = (
    <div className={estiloTelaMapaUtilizacao.cabecalho}>
      <div className={estiloTelaMapaUtilizacao.tituloBotao}>
        <Titulo tipo="cabecalho1" cor={Cores.CoresIdentidadeMU.azulMu} negrito={true}>
          Mapa De Utilização
        </Titulo>

        <Botao tipoComportamento="button" onClick={() => {}} estilo="primaryDark">
          <Icone nome="download" cor={Cores.CoresIdentidadeMU.brancoMu} />
          <Corpo tipo="button1" cor={Cores.CoresIdentidadeMU.brancoMu} negrito={700}>
            Exportar
          </Corpo>
        </Botao>
      </div>

      <div className={estiloTelaMapaUtilizacao.Select}>
        <Select
          tamanho={'small'}
          titulo={''}
          placeholder=""
          onChange={() => {}}
          opcoesMenu={[]}
          regraTexto={(item: any) => item.toString()}
        />
      </div>
    </div>
  )

  const cardIdentificacaoTextos = (
    <div className={estiloTelaMapaUtilizacao.cardIdentificacao}>
      <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTitulo}>
        <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTituloEsquerdo}>
          <Titulo
            tipo="cabecalho2"
            negrito={true}
            cor={Cores.CoresIdentidadeMU.azulEscuroMu}
            conteudo="Identificação"
          />
          <Corpo
            tipo="body3"
            negrito={700}
            cor={Cores.TextoPadrao.CinzaMU600}
            conteudo={`última Atualização: 01/01/2025`}
          ></Corpo>
        </div>
        <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTituloDireito}>
          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTituloDireitoLinhas}>
            <Corpo
              tipo="body3"
              negrito={700}
              cor={Cores.TextoPadrao.CinzaMU600}
              conteudo="Entrevistado(s):"
            ></Corpo>
            <Corpo tipo="body3" cor={Cores.TextoPadrao.CinzaMU600} conteudo="João Silva"></Corpo>
            <Corpo
              tipo="body3"
              cor={Cores.TextoPadrao.CinzaMU600}
              conteudo="| Proprietário |"
            ></Corpo>
            <Corpo
              tipo="body3"
              cor={Cores.TextoPadrao.CinzaMU600}
              conteudo="joao.silva@email.com"
            ></Corpo>
          </div>
          <div
            className={estiloTelaMapaUtilizacao.cardIdentificacaoTituloDireitoLinhas}
            style={{ alignSelf: 'flex-end' }}
          >
            <Corpo
              tipo="body3"
              cor={Cores.TextoPadrao.CinzaMU600}
              conteudo="Maria Oliveira"
            ></Corpo>
            <Corpo tipo="body3" cor={Cores.TextoPadrao.CinzaMU600} conteudo="| TI |"></Corpo>
            <Corpo
              tipo="body3"
              cor={Cores.TextoPadrao.CinzaMU600}
              conteudo="maria.oliveira@email.com"
            ></Corpo>
          </div>
        </div>

        <div className={estiloTelaMapaUtilizacao.cardIdentificacaoBody}>
          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTextos}>
            <Corpo tipo="body1" negrito={700} cor={Cores.CoresIdentidadeMU.azulEscuroMu}>
              Cliente:{' '}
            </Corpo>
            <Corpo
              tipo="body1"
              cor={Cores.CoresIdentidadeMU.azulEscuroMu}
              conteudo="Cliente Fictício"
            ></Corpo>
          </div>

          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTextos}>
            <Corpo tipo="body1" negrito={700} cor={Cores.CoresIdentidadeMU.azulEscuroMu}>
              Ramo de Atividade:
            </Corpo>
            <Corpo
              tipo="body1"
              cor={Cores.CoresIdentidadeMU.azulEscuroMu}
              conteudo="Tecnologia da Informação"
            ></Corpo>
          </div>

          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTextos}>
            <Corpo tipo="body1" negrito={700} cor={Cores.CoresIdentidadeMU.azulEscuroMu}>
              Diretor Responsável:
            </Corpo>
            <Corpo
              tipo="body1"
              cor={Cores.CoresIdentidadeMU.azulEscuroMu}
              conteudo="João Silva | joao.silva@email.com"
            ></Corpo>
          </div>

          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTextos}>
            <Corpo tipo="body1" negrito={700} cor={Cores.CoresIdentidadeMU.azulEscuroMu}>
              TI Responsável:
            </Corpo>
            <Corpo
              tipo="body1"
              cor={Cores.CoresIdentidadeMU.azulEscuroMu}
              conteudo="Maria Oliveira | maria.oliveira@email.com"
            ></Corpo>
          </div>

          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTextos}>
            <Corpo tipo="body1" negrito={700} cor={Cores.CoresIdentidadeMU.azulEscuroMu}>
              Versão utilizada:
            </Corpo>
            <Corpo tipo="body1" cor={Cores.CoresIdentidadeMU.azulEscuroMu} conteudo="1.0.0"></Corpo>
          </div>

          <div className={estiloTelaMapaUtilizacao.cardIdentificacaoTextos}>
            <Corpo tipo="body1" negrito={700} cor={Cores.CoresIdentidadeMU.azulEscuroMu}>
              Data de início de utilização do sistema:
            </Corpo>
            <Corpo
              tipo="body1"
              cor={Cores.CoresIdentidadeMU.azulEscuroMu}
              conteudo="01/01/2020"
            ></Corpo>
          </div>
        </div>
      </div>
    </div>
  )

  const cardInformacao = (
    <div className={estiloTelaMapaUtilizacao.cardInformacao}>
      <div className={estiloTelaMapaUtilizacao.cardInformacaoTitulo}>
        <Icone
          nome="info"
          cor={Cores.CoresIdentidadeMU.azulEscuroMu}
          altura="38px"
          largura="38px"
        />
        <Titulo
          tipo="cabecalho1"
          negrito={true}
          cor={Cores.CoresIdentidadeMU.azulEscuroMu}
          conteudo="Informação Importante"
        />
      </div>
      <Corpo
        tipo="body1"
        cor={Cores.TextoPadrao.CinzaMU600}
        conteudo="Os módulos, processos e rotinas citados representam recursos que existem no ERP Microuniverso,
                entretanto alguns módulos, processos e rotinas podem NÃO funcionar adequadamente com outros módulos, 
                processos e rotinas, dependendo dos parâmetros definidos no banco de dados, assim, caso tenha interesse 
                por algum dos recursos citados aqui, é necessário entrar em contato com a equipe de Base da MicroUniverso
                para que um gerente de projeto analise a rotina desejada e conclua se ela será compatível com as outras
                rotinas em uso atualmente na empresa, somente depois desta análise que podemos avançar com a implantação
                das rotinas desejadas."
      />
      <div></div>
    </div>
  )

  return (
    <div className={estiloTelaMapaUtilizacao.principal}>
      {cabecalho}
      <div className={estiloTelaMapaUtilizacao.secao01}>{cardIdentificacaoTextos}</div>
      <div className={estiloTelaMapaUtilizacao.secao02}>{cardInformacao}</div>
    </div>
  )
}

export { TelaMapaUtilizacao }
